import React from 'react';
import { Input } from '@flixbus/honeycomb-react';

import { VoucherFormSection } from '../Section';

import { useVoucherFormContext } from '../Context';
import { Asterisk } from '../Asterisk';
import {
  MAX_LENGTH,
  MIN_LENGTH,
  MIN_LENGTH_ERROR,
  useCampaignCodeValidation,
} from './useCampaignCodeValidation';

const HELPER_TEXT = `${MIN_LENGTH_ERROR}, uppercase letters and numbers only`;

const CampaignCode = () => {
  const {
    formState: {
      payload: { prefix },
    },
    setFormState,
    setFormError,
    formErrors,
  } = useVoucherFormContext();

  const { isChecking } = useCampaignCodeValidation(prefix, setFormError);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');

    setFormState(prev => ({
      ...prev,
      payload: {
        ...prev.payload,
        prefix: value,
        codeLength: value.length,
      },
    }));
  };

  const error = formErrors.campaignCode;
  const isValid = !error && !isChecking && prefix.length >= MIN_LENGTH;
  const info = isChecking ? 'Checking code availability…' : HELPER_TEXT;

  return (
    <VoucherFormSection
      title='Campaign code'
      subtitle='A single, multi-use code with no random characters appended.'
      inputs={
        <Input
          name='campaign-code'
          id='campaign-code'
          label={
            <>
              Code <Asterisk />
            </>
          }
          type='text'
          required
          value={prefix}
          maxLength={MAX_LENGTH}
          valid={error ? false : isValid ? true : undefined}
          infoError={error}
          info={error ? undefined : info}
          onChange={handleChange}
        />
      }
    />
  );
};

export default CampaignCode;
